const API_BASE = 'https://accountability-coach-worker.manish-clicks.workers.dev'; // Uses Vite proxy in dev, same origin in production

function getHeaders(): HeadersInit {
  const userId = localStorage.getItem('userId');
  return {
    'Content-Type': 'application/json',
    'X-User-ID': userId || '',
  };
}

async function handleResponse<T>(res: Response): Promise<T> {
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || `HTTP ${res.status}`);
  }
  return res.json();
}

export const api = {
  // Goals
  getGoals: () => fetch(`${API_BASE}/api/goals`, { headers: getHeaders() }).then(handleResponse),
  createGoal: (data: Record<string, unknown>) =>
    fetch(`${API_BASE}/api/goals`, { method: 'POST', headers: getHeaders(), body: JSON.stringify(data) }).then(handleResponse),
  updateGoal: (id: string, data: Record<string, unknown>) =>
    fetch(`${API_BASE}/api/goals/${id}`, { method: 'PUT', headers: getHeaders(), body: JSON.stringify(data) }).then(handleResponse),
  deleteGoal: (id: string) =>
    fetch(`${API_BASE}/api/goals/${id}`, { method: 'DELETE', headers: getHeaders() }).then(handleResponse),

  // Progress
  logProgress: (goalId: string, data: Record<string, unknown>) =>
    fetch(`${API_BASE}/api/progress/${goalId}`, { method: 'POST', headers: getHeaders(), body: JSON.stringify(data) }).then(handleResponse),
  getProgress: (goalId: string) =>
    fetch(`${API_BASE}/api/progress/${goalId}`, { headers: getHeaders() }).then(handleResponse),
  deleteProgress: (logId: string) =>
    fetch(`${API_BASE}/api/progress/${logId}`, { method: 'DELETE', headers: getHeaders() }).then(handleResponse),

  // Dashboard
  getDashboard: () => fetch(`${API_BASE}/api/dashboard`, { headers: getHeaders() }).then(handleResponse),

  // Settings
  getSettings: () => fetch(`${API_BASE}/api/settings`, { headers: getHeaders() }).then(handleResponse),
  regenerateShare: () =>
    fetch(`${API_BASE}/api/settings/regenerate-share`, { method: 'POST', headers: getHeaders() }).then(handleResponse),
  toggleShare: (enabled: boolean) =>
    fetch(`${API_BASE}/api/settings/toggle-share`, { method: 'POST', headers: getHeaders(), body: JSON.stringify({ enabled }) }).then(handleResponse),

  // Public
  getPublicProfile: (shareId: string) =>
    fetch(`${API_BASE}/public/share/${shareId}`).then(handleResponse),
};
